// Images
require.context("@/images/front", true);

// CSS
import "swiper/swiper-bundle.css";
import "simplebar/dist/simplebar.min.css";
import "@/stylesheets/front/style.scss";

// JS
import "jquery";
import "swiper";
import "simplebar";
import "@/src/front/common";
import "@/src/front/help";
import "@/controllers/front";
